import axios from 'axios';
import { supabase } from '../supabase';
import { paymentApiRuntime } from '@/config/featureFlags';

const AUTH_REQUIRED_CODE = 'AUTH_REQUIRED';

const PAYMENTS_BASE_URL = paymentApiRuntime.paymentsBaseURL;

// PAY-05：会话缺失时显式抛出，避免带空 header 继续请求支付接口（匿名请求 / 含混的 401）。
// 错误 code 用于上层（Dashboard getErrorStatus）映射为 401，触发重新登录，而非崩溃。
export class AuthRequiredError extends Error {
    constructor(message = 'Authentication required: missing access token') {
        super(message);
        this.name = 'AuthRequiredError';
        this.code = AUTH_REQUIRED_CODE;
    }
}

const getAuthHeaders = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) {
        throw new AuthRequiredError();
    }
    return {
        Authorization: `Bearer ${session.access_token}`
    };
};

const paymentService = {
    async getPrices() {
        const response = await axios.get(`${PAYMENTS_BASE_URL}/prices/`);
        return response.data;
    },

    async createCheckout(lookupKey, requestId) {
        const headers = await getAuthHeaders();
        const response = await axios.post(
            `${PAYMENTS_BASE_URL}/checkout/`,
            {
                lookup_key: lookupKey,
                request_id: requestId
            },
            {
                headers: {
                    ...headers,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    },

    async confirmCheckout(checkoutSessionId) {
        const headers = await getAuthHeaders();
        const response = await axios.post(
            `${PAYMENTS_BASE_URL}/confirm/`,
            {
                checkout_session_id: checkoutSessionId
            },
            {
                headers: {
                    ...headers,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    },

    async createPortal(requestId) {
        const headers = await getAuthHeaders();
        const response = await axios.post(
            `${PAYMENTS_BASE_URL}/portal/`,
            {
                request_id: requestId
            },
            {
                headers: {
                    ...headers,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    },

    async getStatus() {
        const headers = await getAuthHeaders();
        const response = await axios.get(`${PAYMENTS_BASE_URL}/status/`, {
            headers
        });
        return response.data;
    }
};

export default paymentService;
